export enum MediaEnum {
  Video = "video",
  Photo = "photo",
}

export enum EventTypeEnum {
  CustomQuestions = -1,
  Wedding = 0,
  BabyShower = 1,
  Birthday = 2,
  BachelorAndBacheloretteParty = 3,
  Other = 6,
  CompanyEvent = 7,
}

export enum PaymentAmountType {
  Undefined = 0,
  OnlyAdvance = 1,
  FullDeviceAmount = 2,
  FullDeviceAmountWithDeposit = 3,
}

export enum PaymentStatus {
  PaymentNotPayed = 0 /**nincs fizetve */,
  PaymentDeposit = 1 /**Előleg fizetve */,
  PaymentPayed = 2 /** Teljes összeg fizetve */,
  PaymentRefunded = 3,
  DevicePaidDepositNot = 4 /**eszköz fizetve kaució nem */,
  PaymentGratis = 5 /** gratis - no payment required */,
  PendingPayment = 6 /** checkout started, payment not confirmed yet */,
  BookingCancelled = 7 /** fully refunded, the booking is cancelled */,
  PaymentCancelled = 99 /** close to event and not fully paid */,
}

export enum PaymentOption {
  FullPayment = 0,
  ServiceFee = 1,
  AdvanceFee = 2,
  NoPayment = 3,
}

export enum ServicePackageEnum {
  Basic = 0,
  Premium = 1,
}

export enum ShowGalleryStatusEnum {
  no = 0,
  onlyPhoto = 1,
  photoAndVideo = 2,
}

export enum ExtraItemName {
  MagicAi = "MagicAi",
  MemoBook = "MemoBook",
  QuestionCard = "QuestionCard",
}
